var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{staticClass:"permissions",attrs:{"query":_vm.PERMISSIONS_DICTIONARY_QUERY},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [_c('alert',{attrs:{"error":error}}),_c('permission-list',_vm._g(_vm._b({attrs:{"permissions-dictionary":(data && data.permissionsDictionary) || [],"loading":loading,"permissions":_vm.permissions}},'permission-list',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }